import React, { useState } from "react";
import Header from "../../../commons/header/header";
import Footer from "../../../commons/footer/footer";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
} from "@mui/material";
import "../committee.css"; // Import the CSS file

const ANTIDRUG = () => {
  const [selectedTab, setSelectedTab] = useState("committee");

  const committeeRows = [
    {
      id: 1,
      name: "Dr. Eswaramoorthi P",
      position: "Chairman",
      designation: "Principal",
      mobile: "7708069402",
      email: "acetcoimbatore@gmail.com",
      address: "5,6 Perumal Kovil Street, Saravanampatti, Coimbatore- 641 035",
    },
    {
      id: 2,
      name: "Mrs. Selvi P",
      position: "Member",
      designation: "Police Inspector",
      mobile: "9498104851",
      email: "kovilpalayamps2016@gmail.com",
      address:
        "Police Quarters, Police Quarters Road - Kovilpalayam - 641 107, Coimbatore",
    },
    {
      id: 3,
      name: "Mr. Sivakumar AV",
      position: "Member",
      designation: "Revenue/Taluk/Civil Officers",
      mobile: "9940880903",
      email: "thasildharannur@gmail.com",
      address:
        "Annur Thasildhar Office, Sathy Main Road - Annur - 641 035, Coimbatore",
    },
    {
      id: 4,
      name: "Ms. Padmavathi R",
      position: "Member",
      designation: "NGO",
      mobile: "9043883964",
      email: "padmavathimmampalayam@gmail.com",
      address: "9/281, Thimmampalayam - Karamadai - 641 104, Coimbatore",
    },
    {
      id: 5,
      name: "Mr. Senthilbabu",
      position: "Member",
      designation: "Assistant Professor",
      mobile: "9003555774",
      email: "senthilbabu.d@gmail.com",
      address: "1/301, Rangampalayam, Sirumagai, Coimbatore -641302",
    },
    {
      id: 6,
      name: "Mr. Praveen M S",
      position: "Member",
      designation: "Assistant Professor",
      mobile: "9629132432",
      email: "mecpraveen@gmail.com",
      address: "2 - 6 M S Bhavan, Kulathuvilagam, Kanyakumari-629 804",
    },
    {
      id: 7,
      name: "Mr. Ramamoorthy R",
      position: "Member",
      designation: "Representatives of Parents",
      mobile: "9698641793",
      email: "logadharshini245@gmail.com",
      address: "3/407, Amman Pudhur, Pethikuttai, Mettuplalayam-638459",
    },
    {
      id: 8,
      name: "Miss. Vinisha A",
      position: "Member",
      designation: "Representatives of Students",
      mobile: "9597655893",
      email: "vinifaro2208@gmail.com",
      address: "430, Pattakaram Pudur, Annur, 641653",
    },
    {
      id: 9,
      name: "Mr. Mouleeswaran S",
      position: "Member",
      designation: "Representatives of Students",
      mobile: "9597223332",
      email: "mouleea1423@gmail.com",
      address: "144, Vinayagar Kovil Street, Thoosu Nagar, Kallipatti 638505",
    },
    {
      id: 10,
      name: "Mr. Senthilkumar E",
      position: "Member",
      designation: "Lab Technician",
      mobile: "8643814364",
      email: "senthilleela1964@gmail.com",
      address: "132, Thudiyalur Main Road - Idikarai - 641 022, Coimbatore",
    },
  ];

  // Placeholder data for other tabs (replace with actual data if available)
  const squadRows = [];
  const monitoringRows = [];
  const boysHostelRows = [];
  const girlsHostelRows = [];

  // Determine rows based on selected tab
  const getRows = () => {
    switch (selectedTab) {
      case "committee":
        return committeeRows;
      case "squad":
        return squadRows;
      case "monitoring":
        return monitoringRows;
      case "boysHostel":
        return boysHostelRows;
      case "girlsHostel":
        return girlsHostelRows;
      default:
        return [];
    }
  };

    const handlePDFClick = () => {
    window.open(
      `${process.env.PUBLIC_URL}/pdf/ad_minutes_of_meeting.pdf`,
      "_blank"
    );
  };

  return (
    <>
      <Header />
      <div className="antiragging-container">
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          width="100%"
        >
          {/* Left side menu */}
          <Box
            flex={{ xs: "none", sm: "0 0 200px" }}
            bgcolor="transparent"
            p={2}
            display="flex"
            flexDirection="column"
            alignItems="stretch"
            gap={1}
            sx={{
              "@media (max-width: 600px)": {
                flex: "0 0 auto",
              },
              "@media (min-width: 600px)": {
                flex: "0 0 200px",
              },
            }}
          >
            <Button
              variant={selectedTab === "committee" ? "contained" : "outlined"}
              onClick={() => setSelectedTab("committee")}
              style={{
                width: "100%",
                color: selectedTab === "committee" ? "#FFF" : "#000",
                borderColor: selectedTab === "committee" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Anti-Drug Committee
            </Button>
            <Button
              variant={selectedTab === "committee" ? "contained" : "outlined"}
              onClick={handlePDFClick}
              style={{
                width: "100%",
                color: selectedTab === "committee" ? "#FFF" : "#000",
                borderColor: selectedTab === "committee" ? "#FFF" : "#80deea",
                borderWidth: "2px",
              }}
            >
              Minutes Of Meeting
            </Button>
          </Box>

          {/* Right side content */}
          <Box flex="1" p={2}>
            <h2>
              {selectedTab === "committee"
                ? "Anti-Drug Committee"
                : selectedTab === "squad"
                ? "Anti-Ragging Squad"
                : selectedTab === "monitoring"
                ? "Monitoring Cell"
                : selectedTab === "boysHostel"
                ? "Boys Hostel Monitoring Cell"
                : "Girls Hostel Monitoring Cell"}
            </h2>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      S.No.
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Position
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Designation/Occupation
                    </TableCell>
                    <TableCell
                      sx={{ backgroundColor: "#01366b", color: "white" }}
                    >
                      Mobile Numbers
                    </TableCell>
                    {selectedTab === "committee" && (
                      <>
                        <TableCell
                          sx={{ backgroundColor: "#01366b", color: "white" }}
                        >
                          Emailid
                        </TableCell>
                        <TableCell
                          sx={{ backgroundColor: "#01366b", color: "white" }}
                        >
                          Address
                        </TableCell>
                      </>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getRows().length > 0 ? (
                    getRows().map((row, index) => (
                      <TableRow
                        key={row.id}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "white" : "#f1f8e9",
                        }}
                      >
                        <TableCell>{row.id}</TableCell>
                        <TableCell>{row.name}</TableCell>
                        <TableCell>{row.position}</TableCell>
                        <TableCell>{row.designation}</TableCell>
                        <TableCell>{row.mobile}</TableCell>
                        {selectedTab === "committee" && (
                          <>
                            <TableCell>{row.email}</TableCell>
                            <TableCell>{row.address}</TableCell>
                          </>
                        )}
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={selectedTab === "committee" ? 7 : 5}
                        align="center"
                      >
                        No data available for this category.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
      </div>
      <Footer />
    </>
  );
};

export default ANTIDRUG;
